export enum SubStepEnum {
  None = 0,
  Installations = 1,
  Boards = 2,
  Posts = 3,
  DecorativeBoards = 4,
  Decors = 5,
  Panels = 6,
  Doors = 7,
}
